import { render, staticRenderFns } from "./UploudeImages.vue?vue&type=template&id=1edecc10&"
import script from "./UploudeImages.vue?vue&type=script&lang=js&"
export * from "./UploudeImages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports